import React, { Component } from 'react'

class Modal extends Component {
  render() {
    return (
      <div className='modal-container'>
        <div className='modal'>{this.props.children}</div>
      </div>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js